<template>
  <SocialMarketingCardContainer :inProgress="inProgress">
    <div class="card-p-3 flex-1 d-flex flex-column justify-content-between">
      <SocialMarketingStudioInfo
        class="mb-4"
        color="dark"
        :studioUrl="studioUrl"
      />
      <SocialMarketingStudioContent
        :title="marketingAsset.title"
        :description="marketingAsset.description"
        :descriptionMaxLines="6"
      />
    </div>
  </SocialMarketingCardContainer>
</template>

<script>
import SocialMarketingCardContainer from '@/web/components/marketing/SocialMarketingCardContainer.vue';
import SocialMarketingStudioInfo from '@/web/components/marketing/SocialMarketingStudioInfo.vue';
import SocialMarketingStudioContent from '@/web/components/marketing/SocialMarketingStudioContent.vue';

export default {
  name: 'Template4',
  components: {
    SocialMarketingCardContainer,
    SocialMarketingStudioInfo,
    SocialMarketingStudioContent,
  },
  computed: {
    marketingAsset() {
      return this.value;
    },
  },
  props: {
    value: {
      type: Object,
      default: () => ({}),
    },
    inProgress: {
      type: Boolean,
      default: false,
    },
    isDownload: {
      type: Boolean,
      default: false,
    },
    studioUrl: {
      type: String,
      default: '',
    },
    backgroundGradient: {
      type: String,
      default:
        'linear-gradient(360deg, rgba(16, 22, 24, 0.80) 0%, rgba(16, 22, 24, 0.00) 100%)',
    },
    editMode: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/web/styles/components-variables.scss';

.card-p-3 {
  padding: 16px * $social-marketing-card-factor;
}

.card-mb-3 {
  margin-bottom: 16px * $social-marketing-card-factor;
}

.card-mt-3 {
  margin-top: 16px * $social-marketing-card-factor;
}

.card-pt-3 {
  padding-top: 16px * $social-marketing-card-factor;
}

.card-pt-4 {
  padding-top: 32px * $social-marketing-card-factor;
}
</style>
